import React, { ReactNode } from 'react';
import { Button, Dropdown as DropdownAntd } from 'antd';
import type { DropdownProps as AntdDropdownProps, MenuProps } from 'antd';
import './Dropdown.scss';

export interface DropdownItemType {
  key?: React.Key;
  label?: ReactNode;
  prevIcon?: ReactNode;
  nextIcon?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  danger?: boolean;
}

export interface DropdownProps extends Omit<AntdDropdownProps, 'menu'> {
  name?: ReactNode;
  items: DropdownItemType[] | MenuProps['items'];
  width?: string | number;
  onClick?: MenuProps['onClick'];
  children?: ReactNode;
}

export const Dropdown: React.FC<DropdownProps> = ({ 
  name, 
  items, 
  width,
  onClick, 
  children, 
  placement = "bottomLeft", 
  ...rest 
}) => {

  const processItems = (): MenuProps['items'] => {
    if (!items || !items.length) return [];
    
    const isCustomFormat = (items as any[]).some(item => 'prevIcon' in item || 'nextIcon' in item);

    if (isCustomFormat) {
      return (items as DropdownItemType[]).map((item, idx) => ({
        key: item.key || String(idx),
        disabled: item.disabled,
        danger: item.danger,
        onClick: item.onClick,
        label: (
          <div className="custom-dropdown-item">
            {item.prevIcon && <span className="custom-dropdown-icon prev-icon">{item.prevIcon}</span>}
            <span className="custom-dropdown-label">{item.label}</span>
            {item.nextIcon && <span className="custom-dropdown-icon next-icon">{item.nextIcon}</span>}
          </div>
        )
      }));
    }

    return items as MenuProps['items'];
  };

  const menuStyle = width ? { width, maxWidth: '100%' } : undefined;
  const overlayClass = ['custom-dropdown-overlay', rest.overlayClassName].filter(Boolean).join(' ');

  return (
    <DropdownAntd 
      trigger={rest.trigger || ['hover', 'click']} 
      menu={{ items: processItems(), onClick, style: menuStyle }} 
      placement={placement} 
      getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
      {...rest}
      overlayClassName={overlayClass}
      rootClassName="custom-dropdown-menu"
    >
      {children || <Button>{name}</Button>}
    </DropdownAntd>
  );
};

